import CodingCardField from "@/components/CodingCardField";
import TD, { TopDownFormProps } from "@/components/forms/TopDownForm";
import {
  CodeableConceptModel,
  CodingModel,
} from "@/data-models/value-models/structs";
import {
  ICodeableConcept,
  IHumanReadableCoding,
} from "@/data-models/value-models/types";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { assert, boolean, optional, type } from "superstruct";

type FieldValues = {
  unit: IHumanReadableCoding | null;
  quantity: IHumanReadableCoding | null;
  hideLabel?: boolean;
};

interface PropertiesFormProps
  extends Omit<TopDownFormProps<FieldValues>, "onSubmit"> {
  valueSet?: string;
  onSubmit?: (values: {
    code: ICodeableConcept;
    unit: IHumanReadableCoding;
    hideLabel?: boolean;
  }) => void;
}
const DEFAULT_VALUESET =
  "http://tiro.health/fhir/ValueSet/snomed-ct-auto-generated";
function PropertiesForm({
  defaultValues,
  onSubmit,
  valueSet = DEFAULT_VALUESET,
}: PropertiesFormProps) {
  const { t } = useTranslation();
  // Add code validation
  const handleSubmit = useCallback(
    (values: FieldValues) => {
      const transformed = {
        code: {
          text: values.quantity?.display,
          coding: [values.quantity],
        },
        unit: values.unit,
        hideLabel: values.hideLabel,
      };
      assert(
        transformed,
        type({
          code: CodeableConceptModel,
          unit: CodingModel,
          hideLabel: optional(boolean()),
        })
      );
      onSubmit && onSubmit(transformed);
    },
    [onSubmit]
  );

  return (
    <TD<FieldValues> onSubmit={handleSubmit} defaultValues={defaultValues}>
      {({ register, control }) => (
        <div>
          <CodingCardField
            name="quantity"
            label="Quantity"
            valueSet={valueSet}
            control={control}
          />
          <TD.Option
            {...register("hideLabel")}
            label={t("hide-label")!}
            small
          />
          <TD.Field
            type="text"
            {...register("unit.display")}
            label="Unit"
            small
          />
          <TD.Field
            type="text"
            {...register("unit.code")}
            label="Unit code"
            small
          />
          <TD.Field
            type="text"
            {...register("unit.system")}
            label="Unit system"
            small
          />
          <TD.Submit small>Update quantity</TD.Submit>
        </div>
      )}
    </TD>
  );
}

export default PropertiesForm;
